import * as React from "react";

const SvgComponent = (props) => (
  <svg width={20} height={22} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M20 3.46C19.88 1.189 13.687.575 10 .575c-3.687 0-10 .62-10 2.947v15.06c0 2.327 6.287 2.953 10 2.953s10-.62 10-2.953V3.46ZM18.667 8.5c-.22.574-3.374 1.634-8.667 1.634a24.966 24.966 0 0 1-7.333-.906v1.386c2.398.597 4.862.884 7.333.854 2.667 0 6.62-.32 8.667-1.334v3.447c-.22.573-3.374 1.633-8.667 1.633a24.966 24.966 0 0 1-7.333-.933v1.387c2.398.597 4.862.883 7.333.853 2.667 0 6.62-.32 8.667-1.333v3.4c-.234.573-3.387 1.633-8.667 1.633-5.28 0-8.467-1.087-8.667-1.64V3.548C1.533 3 4.667 1.908 10 1.908c5.18 0 8.307 1.02 8.667 1.58-.347.58-3.474 1.593-8.667 1.593a25.067 25.067 0 0 1-7.333-.907v1.394A29.02 29.02 0 0 0 10 6.414c2.667 0 6.62-.32 8.667-1.333V8.5Z"
      fill="#4F4F4F"
    />
  </svg>
);

export default SvgComponent;
